/* eslint-disable */
export default {
    login_email_label: "E-mailadres",
    login_email_placeholder: "E-mailadres",
    login_password_label: "Wachtwoord",
    login_password_placeholder: "Wachtwoord",
    login_forgot_password: "Wachtwoord vergeten?",
    login_login_button_label: "Inloggen",
    login_registration_successful: "Registratie geslaagd. Je kunt nu inloggen.",
    login_new_user_title: "Account aanmaken",
    login_activate_your_account: "Activeer je account",
    login_login_label: "Inloggen",
    login_forgot_my_password_label: "Wachtwoord vergeten?",
    login_all_fields_required: "Voer a.j.b. de verplichte velden in",
    login_login_failed: "Inloggen mislukt. Probeer het opnieuw.",
    login_api_general_error: "Er is een fout opgetreden. Probeer het opnieuw.",
    login_forgot_password_title: "Wachtwoord vergeten",
    login_forgot_password_description: "Vul je e-mailadres in en wij zullen je een link sturen om je wachtwoord te wijzigen.",
    login_forgot_password_send: "Verstuur",
    login_forgot_password_email: "E-mailadres",
    login_forgot_password_email_placeholder: "E-mailadres",
    login_forgot_password_email_sent_title: "Binnen enkele minuten ontvang je een e-mail",
    login_forgot_password_email_sent_description: "<ul>\n<li>Indien je e-mailadres bij ons bekend is, ontvang je een e-mail om je wachtwoord te resetten op het door jou ingevoerde e-mailadres.</li>\n<li>Heb je geen e-mail ontvangen? Controleer dan of je het juiste e-mailadres hebt opgegeven of dat de e-mail zich in je spamfolder bevindt.</li>\n<li>Volg de aanwijzingen in de reset-e-mail om je wachtwoord te wijzigen.</li>\n</ul>",
    login_change_password_title: "Wachtwoord wijzigen",
    login_change_password_new_password: "Nieuw wachtwoord",
    login_change_password_new_password_confirm: "Bevestig wachtwoord",
    login_change_password_confirm: "Wijzigen",
    login_change_password_passwords_dont_match: "Deze wachtwoorden komen niet overeen. Probeer het opnieuw.",
    login_forgot_password_all_fields_required: "Voer a.j.b. de verplichte velden in",
    login_password_change_successful: "Je wachtwoord is gewijzigd. Je kunt nu inloggen.",
    login_forgot_password_confirm_title: "Je wachtwoord is gewijzigd",
    login_forgot_password_return_to_persona_fit_app_mobile: "Klik hier om terug te keren naar de Persona.fit app",
    login_forgot_password_return_to_persona_fit_app_desktop: "Open de Persona.fit app op je mobiel om opnieuw in te loggen",
    login_page_title: "Inloggen",
    login_attempts_exceeded_title: "Inloggen mislukt.",
    login_attempts_exceeded_text: "Vanwege te veel mislukte inlogpogingen is je account geblokkeerd. Probeer het later nogmaals.",
    login_two_factor_authentication_invalid_code: "De ingevoerde code is onjuist, probeer het opnieuw.",
    login_two_factor_authentication_title: "Inloggen",
    login_two_factor_authentication_label_a: "Vul de code in die je via het e-mailadres",
    login_two_factor_authentication_label_b: " hebt ontvangen.",
    login_two_factor_authentication_continue: "Volgende",
    login_error_password_reset_same_password: "Je kunt je huidige wachtwoord niet gebruiken. Kies een nieuw wachtwoord.",
    login_select_organisation_page_title: "Selecteer een organisatie",
    login_select_organisation_title: "Welke organisatie wil je openen?",
    login_select_organisation_submit: "Open",
    login_select_organisation_subtitle: "Je kunt kiezen voor een organisatie of een suborganisatie.",
    login_switch_organisation_title: "Wissel organisatie",
    password_rule_min_length: "Het wachtwoord is tenminste 12 karakters lang",
    password_rule_uppercase_count: "Het wachtwoord bevat ten minste 1 hoofdletter",
    password_rule_lowercase_count: "Het wachtwoord bevat ten minste 1 kleine letter",
    password_rule_special_characters_count: "Het wachtwoord bevat ten minste 1 speciaal/leesteken",
    password_rule_digits_count: "Het wachtwoord bevat ten minste 1 cijfer",
    password_rule_passwords_matching: "Wachtwoordvelden komen overeen",
    login_reset_password_expired_title: "Link voor wachtwoord opnieuw instellen verlopen",
    login_reset_password_expired_description: "Uw recente wachtwoordherstellink is verlopen omdat deze al is gebruikt of niet binnen 24 uur is gebruikt. Deze link is eenmalig geldig en verloopt na 24 uur. U kunt een nieuwe link aanvragen via de onderstaande knop.",
    login_button_request_new_link: "Vraag een nieuwe koppeling aan",
    login_reset_password_expired_contact_text: "Als dit probleem zich blijft voordoen",
    login_reset_password_expired_contact_link: "please let us know"
};
